import { plainToInstance } from 'class-transformer'
import { TaskBase } from '@core/entities/task/TaskBase'
import { ITaskPaginated } from '@core/entities/task/TaskPaginated'

export class TaskPaginated extends TaskBase<ITaskPaginated> {
  public static new(payload: unknown): TaskPaginated {
    const entity = plainToInstance(TaskPaginated, payload)

    return entity
  }
}
